import { z } from "zod";

export const RuntimeWarningSeverity = z.enum(["warn", "error"]);
export type RuntimeWarningSeverity = z.infer<typeof RuntimeWarningSeverity>;

export const RuntimeWarningCategory = z.enum([
	"model",
	"behavior",
	"entity",
	"equip_hand",
	"equip_body",
	"equip_world",
	"animation",
	"zone",
	"sound",
	"spawner",
	"player",
]);
export type RuntimeWarningCategory = z.infer<typeof RuntimeWarningCategory>;

export const LocalizedString = z
	.object({
		fr: z.string().min(1),
		en: z.string().min(1),
	})
	.strict();
export type LocalizedString = z.infer<typeof LocalizedString>;

export const RuntimeWarningSpecSchema = z
	.object({
		code: z.string().regex(/^[A-Z][A-Z0-9_]*$/u),
		category: RuntimeWarningCategory,
		severity: RuntimeWarningSeverity,
		blocksPubli: z.boolean(),
		messages: LocalizedString,
		fix: LocalizedString,
	})
	.strict();
export type RuntimeWarningSpec = z.infer<typeof RuntimeWarningSpecSchema>;

export const RuntimeWarningsFileSchema = z
	.object({
		$schema: z.string().optional(),
		warnings: z.array(RuntimeWarningSpecSchema).min(1),
	})
	.strict();
export type RuntimeWarningsFile = z.infer<typeof RuntimeWarningsFileSchema>;

const RuntimeWarningContextPrimitiveSchema = z.union([
	z.string().max(500),
	z.number().finite(),
	z.boolean(),
	z.null(),
]);

const RuntimeWarningContextValueSchema = z.union([
	RuntimeWarningContextPrimitiveSchema,
	z.array(RuntimeWarningContextPrimitiveSchema).max(20),
	z.record(z.string().min(1).max(64), RuntimeWarningContextPrimitiveSchema),
]);

export const RuntimeWarningPayloadSchema = z
	.object({
		itemId: z.string().min(1).max(128),
		code: z.string().regex(/^[A-Z][A-Z0-9_]*$/u),
		severity: RuntimeWarningSeverity,
		context: z.record(z.string().min(1).max(64), RuntimeWarningContextValueSchema),
	})
	.strict();
export type RuntimeWarningPayload = z.infer<typeof RuntimeWarningPayloadSchema>;
